'use client';

import { Prose } from '@/components/ArticleAccessibilityMenu/ArticleAccessibilityTextSize';
import H1 from '@/components/MDX/H1';
import Section from '@/components/Section/Section';
import { GuidelineSectionWithCategoriesWithGuidelines } from '@/resources/guidelines/allGuidelines';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import GuidelinesFilters from './GuidelinesFilters';
import GuidelinesList from './GuidelinesList';

const GuidelinesPage = ({
	guidelineCategorySections,
}: {
	guidelineCategorySections: GuidelineSectionWithCategoriesWithGuidelines[];
}) => {
	// Show certain content only after first render, to prevent 'HTML doesn't match server' error
	const [showContent, setShowContent] = useState<boolean>(false);

	useEffect(() => {
		if (!showContent) setShowContent(true);
	}, []);

	return (
		<Section>
			<main className="mx-auto w-full max-w-3xl px-4 py-12">
				{showContent && (
					<>
						<Prose className="mb-8">
							<H1>Richtlijnen</H1>

							<p>
								Deze richtlijnen zijn een vertaling van de{' '}
								<Link href="/taak/wcag">
									<abbr>WCAG</abbr>
								</Link>
								. Om het minimale niveau van AA te behalen, moet
								ook niveau A behaald zijn. In dit overzicht zijn
								alleen richtlijnen uit AAA meegenomen die ook
								voor de NTR vaak relevant zijn.
							</p>
						</Prose>

						<GuidelinesFilters />
					</>
				)}
				<GuidelinesList
					guidelineCategorySections={guidelineCategorySections}
				/>
			</main>
		</Section>
	);
};

export default GuidelinesPage;
